import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
 /*   {
      path: '/',
      name: '',
      redirect: '/index',
    },*/
    {
      path: '/web9/index(\\d+)(-\\d+)?(_\\d+)?.html',
      name: 'web3',
      component: resolve => require(['@/views/index.vue'], resolve),
    },
    {
      path: '/web8/index(\\d+)(-\\d+)?(_\\d+)?.html',
      name: 'web2',
      component: resolve => require(['@/views/index_red.vue'], resolve),
    },
    {
      path: '/web7/index(\\d+)(-\\d+)?(_\\d+)?.html',
      name: 'web1',
      component: resolve => require(['@/views/index_blue.vue'], resolve),
    },{
      path: '/lead_page',
      name: 'lead_page',
      component: resolve => require(['@/views/lead_page.vue'], resolve),
      meta: {
        title: '报名成功'
      }
    },{
      path: '/carShowTicked',
      name: 'carShowTicked',
      component: resolve => require(['@/views/carShowTicked.vue'], resolve),
    },{
      path: '/selectCar',
      name: 'selectCar',
      component: resolve => require(['@/views/selectCar.vue'], resolve),
      meta:{
        title:'选择车型'
      }
    },{
      path: '/modelPrice',
      name: 'modelPrice',
      component: resolve => require(['@/views/modelPrice.vue'], resolve),
      meta:{
        title:'车型报价'
      }
    },{
      path: '/sh/index_([0-9]*).html',
      name: 'shareCoupon',
      component: resolve => require(['@/views/shareCoupon.vue'], resolve),
      meta:{
        title:'优惠券'
      }
    },{
      path: '/shareGroup',
      name: 'shareGroup',
      component: resolve => require(['@/views/shareGroup.vue'], resolve),
      meta:{
        title:'我的报名'
      }
    },{
      path: '/infoProtect',
      name: 'infoProtect',
      component: resolve => require(['@/views/infoProtect.vue'], resolve),
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js